// extracted by mini-css-extract-plugin
export default {"root":"MoreActionsButton_root__IMUn-","SNWrapper":"MoreActionsButton_SNWrapper__nqlzy","tooltip":"MoreActionsButton_tooltip__GgAyC","button":"MoreActionsButton_button__y+enB"};